// extracted by mini-css-extract-plugin
export default {"pillIconButton":"styles_pillIconButton__7cDoQ","text":"styles_text__GU813","addIcon":"styles_addIcon__C6ib5"};